import * as React from 'react'

import type { ShipmentSmsFeedItem } from '#/entities/shipment'
import { PhoneIcon } from '#/shared/ui/icons'
import { NoteRow } from '#/shared/ui/history-row'

const SMS_DIRECTION = {
  inbound: 'inbound',
  outbound: 'outbound',
} as const

function smsMeta(message: ShipmentSmsFeedItem): React.ReactNode[] {
  const meta: React.ReactNode[] = [message.timestamp]
  if (message.direction === SMS_DIRECTION.inbound) {
    if (message.fromPhoneDisplay) meta.push(message.fromPhoneDisplay)
  } else if (message.toPhonesDisplay) {
    meta.push(message.toPhonesDisplay)
  }
  return meta
}

export function SmsHistoryRow({ message }: { message: ShipmentSmsFeedItem }) {
  return (
    <NoteRow icon={PhoneIcon} title={message.body} meta={smsMeta(message)} />
  )
}
